"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createErrorLink = void 0;
const apollo_link_error_1 = require("apollo-link-error");
const lodash_1 = require("lodash");
const utils_1 = __importDefault(require("../../utils"));
const APOLLO_PRIVATE_CONTEXT_KEYS = ["cache", "getCacheKey", "clientAwareness", "forceFetch"];
const createErrorLink = _ref => {
  let _ref$networkErrorTitl = _ref.networkErrorTitle,
    networkErrorTitle = _ref$networkErrorTitl === void 0 ? () => "Network Error" : _ref$networkErrorTitl,
    _ref$graphQLErrorTitl = _ref.graphQLErrorTitle,
    graphQLErrorTitle = _ref$graphQLErrorTitl === void 0 ? () => "GraphQL Error" : _ref$graphQLErrorTitl,
    handler = _ref.handler;
  return (0, apollo_link_error_1.onError)(_ref2 => {
    let networkError = _ref2.networkError,
      graphQLErrors = _ref2.graphQLErrors,
      operation = _ref2.operation;
    const operationContext = operation.getContext();
    const normalizedContext = Object.keys(operationContext).filter(key => !APOLLO_PRIVATE_CONTEXT_KEYS.includes(key)).reduce((sanitizedContext, key) => Object.assign(Object.assign({}, sanitizedContext), {
      [key]: operationContext[key]
    }), {});
    const networkErrors = networkError ? [{
      error: networkError,
      type: "network",
      title: networkErrorTitle(networkError),
      description: networkError.message,
      operationName: operation.operationName,
      variables: operation.variables,
      statusCode: (0, utils_1.default)(networkError),
      context: normalizedContext
    }] : [];
    (0, lodash_1.chain)(graphQLErrors).map(_ref3 => {
      let originalError = _ref3.originalError,
        message = _ref3.message;
      return {
        error: originalError,
        type: "graphql",
        title: graphQLErrorTitle(originalError),
        description: message,
        operationName: operation.operationName,
        variables: operation.variables,
        statusCode: (0, utils_1.default)(originalError),
        context: normalizedContext
      };
    }).concat(networkErrors).forEach(handler).value();
  });
};
exports.createErrorLink = createErrorLink;
exports.default = exports.createErrorLink;